"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTROL_DESCRIPTOR = exports.WIDGET_CONFIG = exports.APPLICATION_CONFIG = void 0;
exports.APPLICATION_CONFIG = {
    clientId: '',
    position: 'right',
    align: {
        vertical: 'bottom' /* supported: top, bottom, center */,
        horizontal: 'inner' /* supported: screen_edge, element_edge, inner */,
    },
    widgets: [],
    width: {
        max: 370,
    },
    features: {
        darkTheme: true,
        minibar: false,
        voteEmotions: false,
        commentSentiment: false,
    },
    ux: {
        sidePanel: true,
        pauseTriggers: {
            formOpen: false,
            timelineUgcTap: false,
        },
    },
    margins: {
        top: 0,
        bottom: 0,
        min: 0,
        right: 0,
        left: 0,
        rightSmall: 0,
    },
    demoMode: false,
};
exports.WIDGET_CONFIG = {
    player: {
        type: 'custom',
    },
    timeline: {
        embedded: false,
        height: 32,
        overlayVideo: true,
    },
    openOnLoad: false,
};
exports.CONTROL_DESCRIPTOR = {
    height: 60,
    progressBarOffInOverlay: true,
    hideOnPlay: false,
    shownOnLoad: true,
    track: {
        marginRight: 20,
        marginLeft: 20,
        widthPercentage: 100,
    },
    fullScreen: {
        height: 88,
        track: {
            marginRight: 30,
            marginLeft: 30,
            widthPercentage: 100,
        },
    },
    mouse: {
        trackMove: true,
        moveTimeout: 2000,
        hideOnLeave: true,
        showOnEnter: true,
    },
};
//# sourceMappingURL=config.js.map